import { Component, OnInit, Input } from '@angular/core';
import {CustomerCountByMonth} from '../../../models/ViewModels/customerCountByMonth';

@Component({
  selector: 'app-customer-count-view',
  templateUrl: './customer-count-view.component.html',
  styleUrls: ['./customer-count-view.component.scss']
})
export class CustomerCountViewComponent implements OnInit {
    @Input() CustomerCounts =  new Array<CustomerCountByMonth>();
  constructor() { }

  ngOnInit() {
  }

  ngOnChange () {
  }

}
